import manager from '../manager';
import { isEditorPage } from '@/utils/page'
import $ from 'jquery'
manager.add('popup', {
	created(type) {
        if(isEditorPage()){
            $(this.dom).addClass("dec")
            return
        }
        $(this.dom).find(".mask").on("click",()=>{
            $(this.dom).fadeOut()
        })
        $(this.dom).find(".close").on("click",()=>{
            $(this.dom).fadeOut()
        })
        if(type==1){
            $(this.dom).fadeIn()
            return
        }
        if(type==2){
            $(`[href="#module-${this.instanceId}"]`).on("click",e=>{
                e.preventDefault()
                $(this.dom).fadeIn()
            })
        }
	}
})
